<template>
  <div class="animated fadeIn">
 
    <CCard>
      <CCardHeader>
        <strong>Prizes</strong>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CInput label="Title" placeholder="Enter prize name" v-model="title" />
          </CCol>
        </CRow>
        <CRow class="mt-2">
          <CCol sm="12">
            <CInputFile
                label="Image thumbnail"
                vertical
                v-model="image"
                ref="file"
                type="file"
                id="file"
                @change="onImageChange"
            />
            <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
            <label class="text-danger">(Image Size should be (360 X 360) and less than 1 MB)</label>
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <CButton @click="onSubmit" color="primary">
          <CIcon name="cil-check-circle" />Add Bkash Image
        </CButton>
      </CCardFooter>
    </CCard>

    <b-row>
      <b-col>
        <b-card>
          <v-client-table :data="bkashImage" :columns="columns" :options="options">
            <template slot="image" slot-scope="props">
              <div class="center-div">
                <img :src="`${BASE_URL}/${src_image}${props.row.image}`" style="width: 160px;height: 90px;">
              </div>
            </template>
            <template slot="action" slot-scope="props">
              <div>
                <router-link :to="{ name: 'EditbkashImage', params: { id: props.row.id }}"
                >
                                <span
                                    class="btn btn-warning btn-sm m-1"
                                    data-toggle="tooltip" title="Edit"
                                    :href="props.row.id">
                                  <i class="fa fa-edit"></i>
                                </span>
                </router-link>
                                              <span
                                                  class="btn btn-danger btn-sm m-1"
                                                  data-toggle="tooltip"
                                                  title="Delete Redeem"
                                                  :href="props.row.id"
                                                  @click="handleDelete(props.row.id)"
                                              >
                                                  <i class="fa fa-trash"></i>
                                              </span>
              </div>
            </template>
          </v-client-table>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const BASE_URL  = 'https://quizgiri.s3.ap-south-1.amazonaws.com/p';
export default {
  name: "BkashPrizeImage",
  data() {
    return {
      title: "",

      selectedUser: "",
      image: "",
      publishedStatus: false,
      bkashImage : [],
      columns: [
        'image', 'title',  'action'
      ],
      BASE_URL:BASE_URL,
      ADMIN_URL:ADMIN_URL,
      src_image : 'bkash-prize/',


      options: {
        pagination: {nav: 'fixed'},
        filterByColumn: true,
        dateColumns: ['age'],
        toMomentFormat: 'YYYY-MM-DD',
        sortIcon: {base: 'fa fa-sort', up: 'fa fa-sort-up', down: 'fa fa-sort-down', is: 'fa fa-sort'},

      }
    };
  },
  created(){

    axios.get(`${ADMIN_URL}/bkash-prize-image`)
        .then(response => {

          this.bkashImage = response.data.data;
          // this.bkashImage = response.data.data.map(function (item){return item.assign({}, item, item.is_active="true")})
          console.log('resepnse pormo',this.bkashImage);
        })
        .catch(e => {
          console.log("error occurs", e.response);
        });
  },
  methods: {
    onImageChange(e) {
      console.log("event", e[0]);
      this.image = e[0];
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("image", this.image);


      this.$axios
          .post(`${ADMIN_URL}/bkash-image-create`, formData, config)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            window.location.href = "/bkash-image";
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            currentObj.output = error;
            this.$swal("Error", error.response.message, "error");
          });
    },
    handleDelete(bkash_id) {
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if(result.value) {
          // console.log(bkash_id);
          this.deletebkashImage(bkash_id);
        }
      }).catch(error => {
        // console.log('Sweetalert ERROR');
      });
    },
    deletebkashImage(bkash_id) {

      axios.delete(`${ADMIN_URL}/bkash-prize-delete/${bkash_id}`
      )
          .then(response => {
            if(response.data.success===true)
            {
              this.$swal('Deleted', response.data.message, 'success')
            }

            window.location.reload()
          }).catch(error => {
        this.$swal('Not deleted', 'Error occured while deleing', 'info')
        // console.log('Error response :::: ', error.response);
      })
    },
  }
};
</script>

<style scoped>
</style>
